import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BrowserStorageService } from 'src/app/services/browser-storage/browser-storage.service';
import { CartListModel } from 'src/app/models/cart-list.model';
import { CartService } from 'src/app/services/cart/cart.service';
@Injectable({
  providedIn: 'root'
})
export class CartTotalService implements Resolve<any> {

  constructor(private cartService: CartService,
    private sessionService: BrowserStorageService) { }

    resolve(
      route: ActivatedRouteSnapshot,
      state: RouterStateSnapshot
    ): Observable<CartListModel>|Promise<CartListModel>| CartListModel {
      return this.getCartList()
    }

  /**
   * Get Licence Data
   * @returns
   */
  getCartList(): Observable<CartListModel> {
    let cartData: any = {};
      if (!this.sessionService.getSessionData()) {
          let cartData: any = {};
          return of(cartData)
      } else {
        return this.cartService.getCarts().pipe(
          map((response: any) => {
            return response;
          }),
          catchError((error) => {
            return of(cartData);
          })
        )
      }
  }
}
